import React, { useEffect, useState, useRef } from "react";
import { MainContent, PrincipalContainer } from "../Styles/Main/MainContentStyle";
import { useMachineContext } from "../Context/contextMachine";
import { processType, acceptTyCExternal, channel, redirectionUrlHomeBank, proccessIdMock, sessionTokenMock, sdkEnrollmentFace, sdkEnrollmentDocument, sdkAuthenticate, sdkAuthorization, errorCodes, sourceId, MINUTES_CONVERTER_TIMEOUT, codesNoSDK, DEVICE_MOBILE, SECONDS_CHANGE_PAGE_MOCK } from "../shared/Constants/Constants"
import Spinner from "./Spinner/Spinner"
import ReCAPTCHA from "react-google-recaptcha-enterprise";
import { ContainerRecaptcha } from "../Styles/ContainerRecaptcha"
import { LogoBank } from "../Styles/LogoBank"
import Footer from "./Footer/Footer";
import config from "../config"
import { getInternalCode, getErrorModalText, requestCameraPermission } from '../shared/Utilities/functions'
import { HandlerError } from '../HandlerComponents/HandlerError'
import { HandlerFlow } from '../HandlerComponents/HandlerFlow'
import { saveClientLogs } from '../Services/httpServices'
import { initAsyncClient, closeClient, onEvent } from '../Services/AsyncClient';
import { ContainerQr } from '../Components/ContainerQR/ContainerQr'

export function MainBoard() {
  const [machine, send] = useMachineContext();

  // --- UI State ---
  const [showAlertCancel, setShowAlertCancel] = useState(false);
  const [showAlertRenew, setShowAlertRenew] = useState(false);
  const [showModal, setShowModal] = useState(true);
  const [titleError, setTitleError] = useState("");
  const [messageError, setMessageError] = useState("");
  const [iconType, setIconType] = useState("");
  const [secondaryMessageError, setSecondaryMessageError] = useState("");
  const [buttonBack, setButtonBack] = useState(false);

  // --- Control de flujo ---
  const [testMode, setTestMode] = useState(false);
  const [maxDocument, setMaxDocument] = useState(0);
  const [minDocument, setMinDocument] = useState(0);
  const [maxAttempts, setMaxAttempts] = useState(0);
  const [cancelType, setCancelType] = useState(0);
  const [timeOut, setTimeOut] = useState(0);
  const [enabledRefresh, setEnabledRefresh] = useState(false);

  // --- Estado QR y ReCAPTCHA ---
  const [urlMobile, setUrlMobile] = useState("");
  const recaptchaRef = useRef();

  // --- Variables SDK ---
  let enrollment;
  let authentication;
  let transactions;

  const isMatchSpinner = [
    "validateCookie", "validateParameters", "recaptcha", "getBfKey", "generateBfKey",
    "validateClientSoyYo", "decryptData", "checkUserState", "checkTermsAndConditions",
    "saveUserTries", "activateUser", "validateTransaction", "authenticateUser", 
    "enrollmentUser", "authorizeTransaction", "success", "refreshKeyTransaction",
    "refreshKeyActivateUser", "refreshKeyRetries", "checkCameraPermissions", 
    "errorProcess", "redirectWithError", "asyncService", "generateJweQr",
    "prevalidateClient", "decryptDataPrevalidate", "redirectNewFront"
  ];

  useEffect(() => {
    config.sdk.PRODUCTION = config.sdk.PRODUCTION === "true"
    setTimeOut(parseInt(config.TIME_OUT_REDIRECT)*MINUTES_CONVERTER_TIMEOUT)
    if(config.TEST_MODE === "true"){
      setTestMode(true);
      setMinDocument(parseInt(config.TEST_DOCUMENT_MIN))
      setMaxDocument(parseInt(config.TEST_DOCUMENT_MAX))
      setMaxAttempts(parseInt(config.TEST_MAX_ATTEMPS))
    }
  },[]);

  useEffect(() => {
  const stateActions = {
        recaptcha: getRecaptchaToken,
        authenticateUser: authenticateSDK,
        authorizeTransaction: transactionSdk,
        triggerAsyncClient: connectToAsyncClient,
        showProgressMobile: handleShowProgressMobile
    };
    const currentState = machine.value;
    const action = stateActions[currentState];
    if (action) {action()};
  }, [machine.value]);

  /*-------QR----------*/

  useEffect(() => {
    setUrlMobile(machine.context.urlQR)
  },[machine.context.urlQR]);

  /*-------Async client----------*/

  const connectToAsyncClient = async () => {
    if (testMode) {
      // Simulate a successful connection in test mode
      setTimeout(() => {
        send("JWEUSED");
      }, MINUTES_CONVERTER_TIMEOUT * SECONDS_CHANGE_PAGE_MOCK); // Simulate a 3 seconds delay
      return;
    }

    if(!(machine.context.channelId && machine.context.channelSecret)) {
      // Channel ID and Secret are required to connect to the async client
      return;
    }
    // Close any existing client connection before initializing a new one
    closeClient();
    initAsyncClient(config.url.URLASYNC, machine.context.channelId, machine.context.channelSecret);
    onEvent("event.desktop", message => {
      if (message === codesNoSDK.jweUsed.codeLog) {
        send("JWEUSED");
        return;
      }
      if (message === codesNoSDK.failedRecatpchaRetry.codeLog) {
        return;
      }
      send("REDIRECTERROR", { code: message });
    });

    onEvent("event.desktop.success", jws => {
      send("FINISH", { data: { data: jws, resultCode: codesNoSDK.successCode.code } });
    });
  }

  const handleShowProgressMobile = () => {
    if (!testMode) {
      return;
    }

    setTimeout(() => {
      // We go to validateClientSoyYo machine state to continue simulation in test mode
      send("CONTINUE", { deviceType: DEVICE_MOBILE, isDesktopProcessInMobile: true, isTestMode: true });
    },  MINUTES_CONVERTER_TIMEOUT * SECONDS_CHANGE_PAGE_MOCK); // Simulate a 3 seconds delay
  }


  /*-------RECAPTCHA----------*/

  const getRecaptchaToken = async () => {
    let token = null;
    try {
      token = await recaptchaRef.current.executeAsync();
    } catch (error) {
      // Error al obtener el token de reCAPTCHA
    }
    send("SETRECAPTCHAVALUE",{recaptcha: token});
  }

  const setRecaptchaToken = value => {
    const token = value;
    send("SETRECAPTCHAVALUE",{recaptcha: token});
  }

  /*-------SDK ENROLAMIENTO----------*/

  const enrollmentSdk = async () => {
    enrollment = null;
    const body = await getBasicDataBody();
    basicDataRegister(body)
  }

  const getBasicDataBody = async () => {
    return {
      entityId: config.sdk.ENTITY_ID,
      processType: processType,
      documentType: machine.context.documentTypeEq,
      identificationNumber: machine.context.documentNumber,
      phoneIndicative: machine.context.phoneIndicative,
      phoneNumber: machine.context.phone,
      channel: channel,
      email: machine.context.email,
      appIdentifier: config.sdk.APP_IDENTIFIER,
      acceptTyCExternal: acceptTyCExternal
    }
  }

  const basicDataRegister = async data =>{
    if (testMode) {
      handleTestModeBasicDataRegister(data);
      return;
    }
    saveSdkAction('initBasicData');
    enrollment.basicDataRegister(data,
      async success => {
        data.processId = success.data.processId;
        machine.context.processId = data.processId
        const body = await getCaptureFaceBody(data);
        saveClientLogs(machine.context,sourceId.basicDataRegister,sdkEnrollmentFace,success,success)
        captureFaceSdk(body)
      },
      error => {
        saveClientLogs(machine.context,sourceId.basicDataRegister,sdkEnrollmentFace,error,error)
        if(error.code === "EP005") {
          handleCameraError(error);
        } else {
          const bioCode = getInternalCode(error.code, sdkEnrollmentFace)
          const errorMessage = {code: bioCode.code, message: error.message}
          send("REDIRECTERROR",errorMessage);
        }
      }
    );
  }

  const getCaptureFaceBody = async data => {
    return {
      processId: parseInt(data.processId),
      processType: data.processType,
      channel: data.channel,
      entityId: data.entityId,
      identificationNumber: machine.context.documentNumber,
    }
  };

  const handleTestModeBasicDataRegister = async data => {
    data.processId = proccessIdMock
    machine.context.processId = proccessIdMock
    const body = await getCaptureFaceBody(data);
    captureFaceSdk(body)
  };

  const captureFaceSdk = async captureFaceData => {
    if (testMode) {
      handleTestMode("ACTIVATEUSER");
      return;
    }
    saveSdkAction('initCapureFace');
    enrollment.captureFace(captureFaceData, 
      success => {
        saveClientLogs(machine.context,sourceId.captureFace,sdkEnrollmentFace,success.liveness,success)
        switch (success.liveness.code) {
          case "EP006":
            documentValidateSDK(captureFaceData)
            break;
          case "EP004":
            send("ACTIVATEUSER");
            break;
          default: {
            const bioCode = getInternalCode(success.liveness.code, sdkEnrollmentFace)
            error = {code: bioCode.code}
            send("REDIRECTERROR", error);
          }
        }
    },
    error => {
      saveClientLogs(machine.context,sourceId.captureFace,sdkEnrollmentFace,error,error)
      switch (error.code) {
        case "EP007":
          send("SAVETRIES");
          break;
        case "EP005": {
          handleCameraError(error);
          break;
          }
        case "EPF010": {
          const faceData = 'INACTIVITY';
          const errorMessage = getErrorModalText(faceData);
          setModalError(errorMessage)
          send("CAMERAERROR");
          break;
          }
        case "EP003":
          send("SAVETRIESANDOUT");
          break;
        default: {
          const bioCode = getInternalCode(error.code, sdkEnrollmentFace)
          send("REDIRECTERROR", bioCode)
        }
      }
    },
    handleClose);
  }

  const documentValidateSDK = async documentValidateData => {
    saveSdkAction('initDocumentValidate');
    enrollment.documentValidate(documentValidateData,
      _success => {
        saveClientLogs(machine.context,sourceId.documentValidate,sdkEnrollmentDocument,_success,_success)
        send("ACTIVATEUSER");
      },
      error => {
        saveClientLogs(machine.context,sourceId.documentValidate,sdkEnrollmentDocument,error,error)
        switch (error.code) {
          case "EP005": {
            handleCameraError(error);
            break;
            }
          case "EP007":
            send("SAVETRIES");
            break;
          case "EP008":
            send("SAVETRIES");
            break;
          case "EPF010": {
            const errorMessage = getErrorModalText('INACTIVITY');
            setModalError(errorMessage)
            send("CAMERAERROR");
            break;
            }
          default: {
            const bioCode = getInternalCode(error.code, sdkEnrollmentDocument)
            error = {code: bioCode.code, message: error.message}
            send("REDIRECTERROR", error);
          }
        }
      },
      handleClose);
  }

  /*-------SDK AUTENTICACIÓN----------*/

  const authenticateSDK = async () => {
    authentication = null;
    authenticateUser(await getAuthenticationDataBody())
  }

  const getAuthenticationDataBody = async () => {
    return {
      documentType: machine.context.documentTypeEq,
      identificationNumber: machine.context.documentNumber,
      appIdentifier: config.sdk.APP_IDENTIFIER,
      channel: channel,
      entityId: config.sdk.ENTITY_ID
    }
  }

  const authenticateUser = async data => {
    if (testMode) {
      handleTestMode("AUTHENTICATED");
      return;
    }
    saveSdkAction('initAuthenticate');
    authentication.authenticate(data,
      success => {
        saveClientLogs(machine.context,sourceId.authenticate,sdkAuthenticate,success,success)
        if (success.code === "AP001"){
          send("AUTHENTICATED",success.data);
        } else{
          redirectCancelOperation();
        }
      },
      error =>{
        saveClientLogs(machine.context,sourceId.authenticate,sdkAuthenticate,error,error)
        switch (error.code) {
          case "AP002":
            send("SAVETRIES");
            break;
          case "AP003":
            if(error.type === "error" && !error.data.faceData){
              const bioCode = getInternalCode(error.code, sdkAuthenticate)
              send("SAVETRIESANDOUT",bioCode)
            }else{
              handleCameraError(error);
            }
            break;
          default: {
            const bioCode = getInternalCode(error.code, sdkAuthenticate)
            send("REDIRECTERROR",bioCode)
          }}
      },handleClose);
  }

  const handleCameraError = error => {
    const faceData = error.data.faceData || 'DEFAULT';
    const errorMessage = getErrorModalText(faceData);
    setModalError(errorMessage)
    send("CAMERAERROR");
  };

  const handleClose = close => {
    if (close.code === 'ACT_HELP') {
      showModalCancel(0);
    }
  };

  const handleTestMode = action => {
    const isDocumentNumberInRange = machine.context.documentNumber >= minDocument && machine.context.documentNumber <= maxDocument;
    const hasAttemptsRemaining = machine.context.attemps < maxAttempts;
    if (isDocumentNumberInRange && hasAttemptsRemaining) {
        machine.context.attemps = machine.context.attemps + 1;
        send("SAVETRIES");
    } else {
        const success = { data: { sessionToken: sessionTokenMock } };
        send(action, success.data);
    }
  };

  /*-------SDK TRANSACCIÓN----------*/

  const transactionSdk = async () => {
    transactions = null;
    const body = await getTransactionDataBody()
    if (testMode) {
      send("AUTHORIZATIONTRANSACTION");
      return;
    }
    saveSdkAction('initAuthorization');
    transactions.authorization(body,
      _response => {
        saveClientLogs(machine.context,sourceId.authorization,sdkAuthorization,_response,_response)
        send("AUTHORIZATIONTRANSACTION");
     },
      error => {
        saveClientLogs(machine.context,sourceId.authorization,sdkAuthorization,error,error)
        const bioCode = getInternalCode(error.code, sdkAuthorization)
        error = {code: bioCode.code, message: error.message}
        send("REDIRECTERROR", error);
    });
  };

  const getTransactionDataBody = async () => {
    return {
      sessionToken: machine.context.sessionToken,
      transactionId: machine.context.transactionId}
  };

  const saveSdkAction = async action => {
    const result = {code: action}
    const deviceType = machine.context.deviceType ? sourceId.web : sourceId.mobile;
    saveClientLogs(machine.context,deviceType,codesNoSDK,result)
  };

  /*-------Pantallas de contexto, T&C----------*/

  const begin = () => {
    send("CONTINUE");
  };

  const aceptTaC = () => {
    send("ACEPTTERMS");
  };

  const redirectionHome = () => {
    window.location.replace(redirectionUrlHomeBank);
  };

  const restartFlow = () => {
    send("RETRY");
  };

  const continueFlow = () => {
    setShowModal(true)
    setShowAlertCancel(false)
    setShowAlertRenew(false)
  };

  const showModalCancel = cancelTypeSet => {
    setCancelType(cancelTypeSet);
    setShowModal(false)
    setShowAlertCancel(true)
  };

  const updateQr = () => {
    switchRefresh()
    continueFlow()
  };

  const redirectCancelOperation = () => {
    setShowAlertCancel(false)
    const error = errorCodes[cancelType] || errorCodes.default;
    const deviceType = machine.context.deviceType ? sourceId.web : sourceId.mobile;
    saveClientLogs(machine.context,deviceType,errorCodes,{ code: cancelType})
    send("REDIRECTERROR", error);
  };

  const setModalError = errorMessage => {
    setTitleError(errorMessage.title);
    setMessageError(errorMessage.message);
    setIconType(errorMessage.iconType);
    setButtonBack(errorMessage.buttonBack)
    setSecondaryMessageError(errorMessage.secondaryMessage)
  };

  /*-------Pantalla de permisos de camara----------*/

  const tryCameraPermissions = async () => {
    if (testMode) {
      send("CAMERAUNKNOWN");
      return;
    }
    const hasCameraPermissions = await requestCameraPermission()
    if(!hasCameraPermissions.result && hasCameraPermissions.denied) {
      const errorMessage = getErrorModalText('FEEDBACK_CAMERA_ACQUIRING_FAILED');
      setModalError(errorMessage)
      send("CAMERAERROR");
    }else if(hasCameraPermissions.error){ 
      send("CAMERAUNKNOWN",{error: hasCameraPermissions.error});
    }else{
      send("CAMERARESULT");
    }
  };

  /*-------Pantalla de QR----------*/

  const switchRefresh = async () => {
    setEnabledRefresh(!enabledRefresh)
  };

  /*-------RENDER----------*/

  return (
    <div className="App">
      <header className="App-header">
      <PrincipalContainer>
        <MainContent>
        <LogoBank id="errorAlert" />
          {["showQr", "showProgressMobile"].some(machine.matches) && (<ContainerQr urlMobile={urlMobile} isEnable={machine.matches("showProgressMobile")} backFunction={showModalCancel} />)}
          {(isMatchSpinner.some(machine.matches)) && (<Spinner/>)}
          <HandlerError machine={machine} showAlertCancel={showAlertCancel} showAlertRenew={showAlertRenew} continueFlow={continueFlow} redirectCancelOperation={redirectCancelOperation} restartFlow={restartFlow} redirectionHome={redirectionHome} titleError={titleError} messageError={messageError} iconType={iconType} buttonBack={buttonBack} secondaryMessage={secondaryMessageError} timeOutRedirect={timeOut} renewFunction={updateQr}/>
          <HandlerFlow machine={machine} aceptTaC={aceptTaC} begin={begin} cancelOperation={showModalCancel} isShowing={showModal} setRecatpcha={setRecaptchaToken} requestCameraPermissions={tryCameraPermissions}/>
          <ContainerRecaptcha topM="20px" display="flex">
            <ReCAPTCHA
              size="invisible"
              ref={recaptchaRef}
              sitekey={config.RECAPTCHA_KEY}
            />
          </ContainerRecaptcha>
        </MainContent>
        <Footer top="0px" topMovil="100%" />
      </PrincipalContainer>
      </header>
    </div>
  );
}